import { Suspense } from "react";

import ReactDOM from "react-dom/client";
import "./index.scss";
import "./tailwind.css";

import configureApp from "./core/configureApp";
import Routes from "./core/routes";
import { Web3Provider } from "./shared/providers";
import colors from "./theme/colors";

const { apps } = configureApp();

/**
 * Root-level loading fallback with inline styles.
 * Avoids dependencies on CSS bundles that may not be loaded yet.
 */
const RootLoader = () => (
	<div
		style={{
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			height: "100vh",
			width: "100%",
			backgroundColor: colors.black
		}}
	>
		<div
			style={{
				width: 48,
				height: 48,
				border: `3px solid ${colors.grey8}`,
				borderTopColor: colors.greenLime1,
				borderRadius: "50%",
				animation: "spin 1s linear infinite"
			}}
		/>
		<style>{"@keyframes spin { to { transform: rotate(360deg); } }"}</style>
	</div>
);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
	<Suspense fallback={<RootLoader />}>
		<Web3Provider>
			<Routes modules={apps} />
		</Web3Provider>
	</Suspense>
);
